/**
 *
 * key
 *
 */


const key = 'cXVvdGF0aW9u'

export default key